import { render, staticRenderFns } from "./service-auth.vue?vue&type=template&id=fb28f4e2&scoped=true&"
import script from "./service-auth.vue?vue&type=script&lang=ts&"
export * from "./service-auth.vue?vue&type=script&lang=ts&"
import style0 from "./service-auth.vue?vue&type=style&index=0&id=fb28f4e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb28f4e2",
  null
  
)

export default component.exports